

















import { Component, Vue, Prop, Provide, Emit } from 'vue-property-decorator'
interface Tab {
  name: string
  value: string
}
const tabs: Tab[] = [
  { name: '班级错题', value: '1' },
  { name: '年级错题', value: '2' },
  { name: '高频错题', value: '3' }
]
const defaultTab: Tab = { name: '班级错题', value: '1' }
@Component
export default class extends Vue {
  @Prop({
    default() {
      return tabs
    }
  })
  public data!: Tab[]
  @Prop({
    default() {
      return defaultTab
    }
  })
  public defaultTab!: Tab
  @Emit()
  public select(tab: Tab) {
    return tab
  }
}
